function httpPattern() {
  return /^http:\/\//;
}

function secureUrl(url) {
  return httpPattern().test(url) ? url.replace(httpPattern(), "https://") : url;
}

function imgTransformer(tagName, inputAttribs) {
  const attribs = inputAttribs;

  if (attribs.src) {
    attribs.src = secureUrl(attribs.src);
  }

  return { tagName, attribs };
}

const sanitizeSettings = {
  allowedTags: false, // setting this to false allows all tags
  allowedAttributes: false, // setting this to false allows all attributes
  transformTags: {
    img: imgTransformer
  }
};

export default sanitizeSettings;
